import React from "react";
import {Form, Input, Modal, Switch} from "antd";
import {FormModalProps} from "../../../../utils/useFormModal";
import Select from "../../../../components/Select";

function ModifyModal(props: FormModalProps) {
    const {form, ...otherProps} = props
    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'name'} label={'名称'} rules={[{required: true, message: '请输入名称'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'userId'} label={'用户'} rules={[{required: true, message: '请选择用户'}]}>
                    <Select url={'/user/dict'} getData={data => {
                        return data.data.map((item: any) => ({...item, nickName: `${item.nickName}(${item.userName})`}))
                    }} textField={'nickName'} valueField={'id'}/>
                </Form.Item>
                <Form.Item name={'status'} label={'状态'} valuePropName={'checked'} initialValue={true}>
                    <Switch checkedChildren={'启用'} unCheckedChildren={'停用'}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
